export const AdminRoutes = {
  path: 'admin/*',
  lazy: () => import('../pages/admin'),
};
